import {get,  post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const Create = (data: any) =>
POST_ENC(`${BASE_URL}/api/EWayBill/Create`, data);

export const GetDetail = (params: any) =>
 GET_ENC(`${BASE_URL}/api/EWayBill/GetDetail?`+ params, null);

export const Cancel = (data: any) =>
POST_ENC(`${BASE_URL}/api/EWayBill/Cancel`, data);

export const Reject = (data: any) =>
POST_ENC(`${BASE_URL}/api/EWayBill/Reject`, data);

export const UpdateTransporter = (data: any) =>
POST_ENC(`${BASE_URL}/api/EWayBill/UpdateTransporter`, data);

export const UpdatePartB = (data: any) =>
POST_ENC(`${BASE_URL}/api/EWayBill/UpdatePartB`, data);

export const Extend = (data: any) =>
POST_ENC(`${BASE_URL}/api/EWayBill/Extend`, data);

export const Close = (data: any) =>
POST_ENC(`${BASE_URL}/api/EWayBill/Close`, data);

